import gql from 'graphql-tag';

export const PUSH_NOTIFICATIONS = gql`
  query {
    pushNotifications(orderBy: createdAt_DESC) {
      id
      receiver
      title
      subTitle
      body
      comment
      accessPointStatus
      user {
        id
        firstName
        lastName
      }
      changedBy {
        id
        firstName
        lastName
      }
      createdAt
    }
  }
`;

export const SEND_PUSH_NOTIFICATION = gql`
  mutation SEND_PUSH_NOTIFICATION(
    $receiver: RECEIVER!
    $user: String
    $title: String
    $subTitle: String
    $body: String!
    $comment: String!
    $internalUser: String!
  ) {
    sendPushNotification(
      receiver: $receiver
      userId: $user
      title: $title
      subTitle: $subTitle
      body: $body
      comment: $comment
      internalUser: $internalUser
    ) {
      id
    }
  }
`;

export const SEND_UPS_AP_PUSH_NOTIFICATION = gql`
  mutation SEND_UPS_AP_PUSH_NOTIFICATION(
    $receiver: RECEIVER!
    $accessPointId: String
    $accessPointStatus: AccessPointStatus
    $title: String
    $subTitle: String
    $body: String!
    $comment: String!
    $internalUser: String!
  ) {
    sendUpsApPushNotification(
      receiver: $receiver
      accessPointId: $accessPointId
      accessPointStatus: $accessPointStatus
      title: $title
      subTitle: $subTitle
      body: $body
      comment: $comment
      internalUser: $internalUser
    ) {
      id
    }
  }
`;

export const GET_UPS_AP_NOTIFICATION_COUNT = gql`
  query GET_UPS_AP_NOTIFICATION_COUNT($receiver: RECEIVER!, $accessPointStatus: AccessPointStatus) {
    upsApPushNotificationCount(receiver: $receiver, accessPointStatus: $accessPointStatus)
  }
`;

export const GET_ALL_ACCESS_POINTS = gql`
  query GET_ALL_ACCESS_POINTS {
    accessPoints(status: [DRAFT, PENDING, WAITLIST, CONFIRMED, ACTIVE, INACTIVE, REJECTED, RETRY]) {
      id
      accessPointID
      status
      isActive
      dropPoint {
        user {
          firstName
          lastName
        }
      }
    }
  }
`;

export type AccessPointForDropdown = {
  id: string;
  accessPointID: string | null;
  status: string;
  isActive: boolean;
  dropPoint: {
    user: {
      firstName: string;
      lastName: string;
    } | null;
  } | null;
};

export type AccessPointsForDropdownQuery = {
  accessPoints: AccessPointForDropdown[];
};
